export const headerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2, // each child animates 0.2s after previous
    },
  },
};
